import type { ApiOrgId } from '#/api/types/ApiTypedId';
import { useLoggedIn } from '#/contexts/UserEnvironmentContext';
import { useUserDashboardApiFetchListingExtras } from '#/modules/userDashboard/api/listingExtras/userDashboardApiFetchListingExtras';

type Args = {
  orgId: ApiOrgId | undefined;
};

export function useUserDashboardOrgInitiallySaved({ orgId }: Args) {
  const { loggedIn } = useLoggedIn();
  const [savedOrgListingExtras] = useUserDashboardApiFetchListingExtras(
    loggedIn && orgId ? [orgId] : [],
  );

  return {
    orgInitiallySaved:
      loggedIn && orgId && savedOrgListingExtras
        ? Boolean(savedOrgListingExtras[orgId])
        : false,
  };
}
